// eslint-disable-next-line max-lines-per-function
define( [ 'utility' ], function run( utility ) {
	'use strict';

	var mMultiselectFn = {

		defaults : {
			pleaseselect : FRAMEWORK.locale.settings.mCheckboxGroupMultiselect.pleaseSelect,
			allselected : FRAMEWORK.locale.settings.mCheckboxGroupMultiselect.allSelected,
			selected : FRAMEWORK.locale.settings.mCheckboxGroupMultiselect.selected,
			selectall : FRAMEWORK.locale.settings.mCheckboxGroupMultiselect.selectAll,
			selectAllStart : '<li class="m-form-row-group-item m-form-row-group-item--full-width">' +
					'<label class="a-checkbox a-checkbox--select-all" for="">' +
						'<input class="a-checkbox__input a-checkbox__input--select-all" type="checkbox" name="checkbox_group" id="" value="" />' +
							'<span class="a-checkbox__label">' +
								'<span class="a-checkbox__label-inner a-checkbox__label-inner--all">',
			selectAllEnd : '</span>' +
						'</span>' +
						'<span class="a-checkbox__ui"></span>' +
				'</label>' +
			'</li>',
		},

		init : function( elm ) {
			var elementId,
				elementLabelId,
				checkboxIndex,
				onResize,
				allElements;

			if ( !elm.classList.contains( 'js-m-multiselect' ) ) {
				elm.classList.add( 'js-m-multiselect' );
				elm.classList.add( 'u-hidden' );

				// Set settings from defaults and any specified options
				elm.mMultiselect = utility.extend({}, mMultiselectFn.defaults, utility.getData( elm ) );
				elm.mMultiselect.scrollTopVal = 0;

				// Provide legends/labels with an id to associate with relevant dropdown box
				elementLabelId = elm.parentElement.previousElementSibling.getAttribute( 'id', elementLabelId );
				if ( !elementLabelId || elementLabelId === '' ) {
					elementLabelId = utility.makeId( 'm-multiselect-label-' );
					elm.parentElement.previousElementSibling.setAttribute( 'id', elementLabelId );
				}

				// Add aria and wrap checkbox-group list
				elm.setAttribute( 'tabindex', '-1' ); // Prevent Firefox from focusing via keyboard
				elm.setAttribute( 'role', 'listbox' );
				elm.setAttribute( 'aria-multiselectable', 'true' );
				elm.mMultiselect.wrapper = utility.htmlStringToElement( '<div class="m-multiselect"></div>' );
				utility.wrap( elm, elm.mMultiselect.wrapper );
				elm.mMultiselect.wrapper.setAttribute( 'aria-labelledby', elementLabelId );

				// Add additional wrapper to ul to hold scrollbar
				elm.mMultiselect.scrollbar = utility.htmlStringToElement( '<div class="m-multiselect-scrollbar"></div>' );
				utility.wrap( elm, elm.mMultiselect.scrollbar );

				elm.mMultiselect.overlay = elm.mMultiselect.variant === 'm-multiselect--overlay';

				// Add wrapper if overlay variant
				if ( elm.mMultiselect.overlay ) {
					utility.wrap( elm.mMultiselect.wrapper, utility.htmlStringToElement( '<div class="m-multiselect-wrapper"></div>' ) );
				}

				elementId = elm.getAttribute( 'id', elementId );
				if ( !elementId || elementId === '' ) {
					elementId = utility.makeId( 'm-multiselect-' );
					elm.setAttribute( 'id', elementId );
				}
				elm.setAttribute( 'aria-hidden', 'true' );

				// Add link element
				elm.mMultiselect.toggle = utility.htmlStringToElement( '<button class="m-multiselect-toggle" type="button" aria-controls="' +
					elementId + '" aria-expanded="false"><span class="m-multiselect-toggle__inner">' +
					elm.mMultiselect.pleaseselect + '</span></button>' );
				elm.mMultiselect.wrapper.prepend( elm.mMultiselect.toggle );
				if ( elm.closest( '.m-form-row' ).classList.contains( 'is-disabled' ) ) {
					elm.mMultiselect.toggle.setAttribute( 'tabindex', -1 );
				}
				elm.mMultiselect.toggleInner = elm.mMultiselect.wrapper.querySelector( '.m-multiselect-toggle__inner' );
				elm.mMultiselect.toggleInnerHeight = elm.mMultiselect.toggleInner.getBoundingClientRect().height;
				if ( elm.mMultiselect.overlay ) {
					elm.mMultiselect.toggleHeight = elm.mMultiselect.wrapper.parentElement.clientHeight;
				}
				elm.prepend( utility.htmlStringToElement( elm.mMultiselect.selectAllStart + elm.mMultiselect.selectall + elm.mMultiselect.selectAllEnd ) );

				// Set checkbox input vars
				elm.mMultiselect.checkboxGroupItems = elm.querySelectorAll( '.m-form-row-group-item' );
				elm.mMultiselect.checkboxInputAll = elm.querySelectorAll( '.a-checkbox__input' );
				elm.mMultiselect.checkboxInputAll.forEach( function loop( checkboxInput ) {
					checkboxInput.setAttribute( 'tabindex', '-1' );
					checkboxInput.setAttribute( 'role', 'option' );
					checkboxInput.setAttribute( 'aria-selected', 'false' );
				});
				elm.mMultiselect.checkboxSelectAll = elm.querySelector( '.a-checkbox__input--select-all' );
				elm.mMultiselect.checkboxInput = elm.querySelectorAll( '.a-checkbox__input:not(.a-checkbox__input--select-all)' );

				// Add unique id to select all input
				elm.mMultiselect.checkboxSelectAll.setAttribute( 'id', utility.makeId( 'select-all__' ) );
				elm.mMultiselect.checkboxSelectAllLabel = elm.querySelector( '.a-checkbox--select-all' );
				elm.mMultiselect.checkboxSelectAllLabel.setAttribute( 'for', elm.mMultiselect.checkboxSelectAll.getAttribute( 'id' ) );

				elm.mMultiselect.toggle.addEventListener( 'click', function listener( e ) {
					e.preventDefault();

					if ( elm.classList.contains( 'u-hidden' ) ) {
						elm.classList.remove( 'u-hidden' );
						elm.setAttribute( 'aria-hidden', 'false' );
						elm.mMultiselect.wrapper.classList.add( 'is-open' );
						elm.mMultiselect.toggle.setAttribute( 'aria-expanded', 'true' );
						elm.mMultiselect.checkboxInputAll.forEach( function loop( thisElement ) {
							thisElement.removeAttribute( 'tabindex' );
						});
						// Check available space and extend page height if overlay variant doesn't fit
						mMultiselectFn.expandWrapper( elm );
						// Reset checkboxIndex for keyboard navigation
						checkboxIndex = undefined;
						// Reset scroll to top on reopen
						elm.mMultiselect.scrollTopVal = 0;
					} else {
						mMultiselectFn.slideUp( elm );
					}
				});

				// Improve keyboard navigation
				// eslint-disable-next-line complexity
				elm.mMultiselect.wrapper.addEventListener( 'keyup', function listener( e ) {
					let array = elm.mMultiselect.checkboxInputAll;
					let last = array[ array.length - 1 ];
					if ( elm.mMultiselect.wrapper.classList.contains( 'has-focus' ) && elm.mMultiselect.wrapper.classList.contains( 'is-open' ) ) {
						// Close element on Escape keypress
						if ( e.key === 'Escape' ) {
							mMultiselectFn.slideUp( elm );
						}
						// Get the index of focused checkbox
						elm.mMultiselect.checkboxInputAll.forEach( function loop( input, i ) {
							if ( input === document.activeElement ) {
								checkboxIndex = i;
							}
						});
						// Navigate checkboxes with down arrow key
						if ( e.key === 'ArrowDown' ) {
							e.preventDefault();
							if ( typeof checkboxIndex !== 'undefined' && array[ checkboxIndex ] !== last ) {
								array[ checkboxIndex + 1 ].focus();
							} else if ( typeof checkboxIndex === 'undefined' ) {
								array[ 0 ].focus();
							}
						}
						// Navigate checkboxes with up arrow key
						if ( e.key === 'ArrowUp' ) {
							e.preventDefault();
							if ( typeof checkboxIndex !== 'undefined' && checkboxIndex !== 0 ) {
								array[ checkboxIndex - 1 ].focus();
							}
						}
					}
				});

				elm.mMultiselect.currentBreakpoint = utility.getBreakpoint();

				elm.mMultiselect.windowWidth = document.body.clientWidth;
				elm.mMultiselect.resizeTimeout = null;

				onResize = utility.debounce( function listener() {
					var newWindowWidth = document.body.clientWidth;
					if ( newWindowWidth !== elm.mMultiselect.windowWidth ) {
						clearTimeout( elm.mMultiselect.resizeTimeout );
						elm.mMultiselect.resizeTimeout = setTimeout( function timeoutFn() {
							elm.mMultiselect.currentBreakpoint = utility.getBreakpoint();
							elm.mMultiselect.windowWidth = newWindowWidth;
							mMultiselectFn.pleaseSelect( elm );
							elm.mMultiselect.scrollTopVal = elm.scrollTop;
							mMultiselectFn.setMaxListHeight( elm );
						}, 10 );
					}
				}, 10 );
				window.addEventListener( 'resize', onResize );
				window.addEventListener( 'refresh', onResize, false );

				// Setup for if options are already selected
				mMultiselectFn.clickCheckbox( elm );
				mMultiselectFn.pleaseSelect( elm );

				allElements = Array.prototype.slice.call( elm.mMultiselect.checkboxInputAll );
				allElements.push( elm.mMultiselect.toggle );
				allElements.push( elm );
				allElements.forEach( function loop( thisElement ) {
					thisElement.addEventListener( 'focus', function listener() {
						elm.mMultiselect.wrapper.classList.add( 'has-focus' );
					});

					thisElement.addEventListener( 'focusout', function listener() {
						var focusedElements;

						// Timeout to ensure that focus has been transfered to another elm before this runs
						setTimeout( function timeoutFn() {
							focusedElements = allElements.filter( function filterFn( el ) {
								return document.activeElement === el;
							});

							if ( focusedElements.length > 0 || document.activeElement === thisElement ) {
								// Do nothing
							} else {
								elm.mMultiselect.wrapper.classList.remove( 'has-focus' );
								if ( elm.mMultiselect.overlay ) {
									mMultiselectFn.slideUp( elm );
								}
							}
						}, 150 );
					});
				});

				mMultiselectFn.checkboxClickFunctions( elm );

				// Click other inputs
				elm.mMultiselect.forceUpdate = function forceUpdate() {
					mMultiselectFn.clickCheckbox( elm );
					mMultiselectFn.pleaseSelect( elm );
				};

				elm.mMultiselect.select = function select( idList ) {
					if ( Array.isArray( idList ) ) {
						idList.forEach( function loop( checkboxId ) {
							// Loop through IDs and check those inputs
							var currentCheckbox = elm.querySelector( checkboxId );
							if ( currentCheckbox ) {
								currentCheckbox.checked = true;
							}
						});

						mMultiselectFn.clickCheckbox( elm );
						mMultiselectFn.pleaseSelect( elm );
					}
				};
				elm.mMultiselect.selectAll = function selectAll() {
					elm.mMultiselect.checkboxInput.forEach( function loop( thisElement ) {
						thisElement.checked = true;
					});

					mMultiselectFn.clickCheckbox( elm );
					mMultiselectFn.pleaseSelect( elm );
				};

				elm.mMultiselect.deselect = function deselect( idList ) {
					if ( Array.isArray( idList ) ) {
						// Loop through IDs and uncheck those inputs
						idList.forEach( function loop( checkboxId ) {
							var currentCheckbox = elm.querySelector( checkboxId );
							if ( currentCheckbox ) {
								currentCheckbox.checked = false;
							}
						});

						mMultiselectFn.clickCheckbox( elm );
						mMultiselectFn.pleaseSelect( elm );
					}
				};
				elm.mMultiselect.deselectAll = function deselectAll() {
					elm.mMultiselect.checkboxInput.forEach( function loop( thisElement ) {
						thisElement.checked = false;
					});

					mMultiselectFn.clickCheckbox( elm );
					mMultiselectFn.pleaseSelect( elm );
				};

				elm.mMultiselect.close = function close() {
					mMultiselectFn.slideUp( elm );
				};
			}

			return elm.mMultiselect;
		},

		checkboxClickFunctions : function( elm ) {
			// Click select all input
			elm.mMultiselect.checkboxSelectAll.addEventListener( 'click', function listener() {
				// Will be checked on click!
				if ( elm.mMultiselect.checkboxSelectAll.checked ) {
					elm.mMultiselect.checkboxInput.forEach( function loop( thisElement ) {
						thisElement.checked = true;
					});
					elm.mMultiselect.checkboxSelectAll.setAttribute( 'aria-selected', 'true' );
				} else {
					elm.mMultiselect.checkboxInput.forEach( function loop( thisElement ) {
						thisElement.checked = false;
					});
					elm.mMultiselect.checkboxSelectAll.setAttribute( 'aria-selected', 'false' );
				}
				mMultiselectFn.clickCheckbox( elm );
				mMultiselectFn.pleaseSelect( elm );
			});

			// Click other inputs
			elm.mMultiselect.checkboxInput.forEach( function loop( thisElement ) {
				thisElement.addEventListener( 'click', function listener() {
					mMultiselectFn.clickCheckbox( elm );
					mMultiselectFn.pleaseSelect( elm );
				});

				thisElement.addEventListener( 'focus', function listener() {
					var parentElement = thisElement.closest( '.m-form-row-group-item' ),
						parentElementHeight = utility.outerHeightTrue( parentElement ),
						elementOffset = parentElement.offsetTop + parentElementHeight,
						parentBottomScroll = elm.scrollTop + utility.outerHeightTrue( elm );

					if ( elementOffset > parentBottomScroll ) {
						elm.scrollTop += parentElementHeight;
					}
				});
			});
		},

		slideUp : function( elm ) {
			elm.mMultiselect.scrollTopVal = elm.scrollTop; // Save the current scrollTop position

			// First part needs to fire after blur timeout function but before the rest
			utility.slideToggle( elm, FRAMEWORK.timings.current.t350ms, {
				variant : 'up',
				callback : function() {
					document.body.style.minHeight = 0;
					elm.setAttribute( 'aria-hidden', 'true' );
					elm.mMultiselect.wrapper.classList.remove( 'is-open' );
					elm.mMultiselect.toggle.setAttribute( 'aria-expanded', 'false' );
					elm.mMultiselect.checkboxInputAll.forEach( function loop( thisElement ) {
						thisElement.setAttribute( 'tabindex', -1 );
					});
					elm.removeAttribute( 'style' );
					elm.classList.add( 'u-hidden' );
					if ( elm.mMultiselect.scrollbar ) {
						elm.mMultiselect.scrollbar.classList.remove( 'is-open' );
						elm.mMultiselect.scrollbar.style.height = 0;
						elm.style.height = 'auto';
					}
				},
			});
		},

		expandWrapper : function( elm ) {
			// Expand scrollbar area gracefully
			elm.mMultiselect.scrollbar.style.height = 'auto';
			mMultiselectFn.setMaxListHeight( elm );
			utility.slideToggle( elm, FRAMEWORK.timings.current.t350ms, {
				variant : 'down',
				customStartHeight : 0,
				customEndHeight : utility.removeMeasurementSuffix( elm.offsetHeight ),
				callback : function() {
					elm.scrollTop = elm.mMultiselect.scrollTopVal; // Reset the scrollTop position
					mMultiselectFn.setWindowHeight( elm );
				},
			});
			elm.mMultiselect.scrollbar.classList.add( 'is-open' );
		},

		setWindowHeight : function( elm ) {
			var bodyHeight,
				scrollbarBottom;

			document.body.style.minHeight = 0;
			bodyHeight = document.documentElement.scrollHeight;

			// Get scrollbar height and expand it gracefully
			setTimeout( function timeoutFn() {
				scrollbarBottom = utility.offset( elm ).top + utility.outerHeightTrue( elm.mMultiselect.scrollbar );
				if ( scrollbarBottom > bodyHeight ) {
					document.body.style.minHeight = utility.convertToPx( scrollbarBottom + elm.mMultiselect.toggleHeight );
				}
			}, FRAMEWORK.timings.current.t350ms );
		},

		clickCheckbox : function( elm ) {
			// Select / deselect checkboxes
			elm.mMultiselect.selectedItems = [];
			elm.mMultiselect.selectedCount = 0;

			elm.mMultiselect.checkboxInput.forEach( function loop( thisElement ) {
				var labelText;
				if ( thisElement.checked ) {
					labelText = thisElement.parentElement.querySelector( '.a-checkbox__label' ).textContent;
					elm.mMultiselect.selectedItems.push( labelText );
					elm.mMultiselect.selectedCount = elm.mMultiselect.selectedItems.length;
					thisElement.setAttribute( 'aria-selected', 'true' );
				} else {
					thisElement.setAttribute( 'aria-selected', 'false' );
				}
			});
		},

		pleaseSelect : function( elm ) {
			var tempHeight;
			// Swap 'Please select...:' text
			elm.mMultiselect.checkboxSelectAll.checked = false;

			if ( elm.mMultiselect.checkboxInput.length === elm.mMultiselect.selectedCount ) {
				// All checked
				elm.mMultiselect.toggleInner.innerHTML = elm.mMultiselect.allselected;
				elm.mMultiselect.toggle.classList.add( 'm-multiselect-toggle__inner--bold' );
				elm.mMultiselect.checkboxSelectAll.checked = true;
			} else if ( elm.mMultiselect.selectedCount === 0 ) {
				// Nothing checked - revert back to 'Please select...' text
				elm.mMultiselect.toggleInner.innerHTML = elm.mMultiselect.pleaseselect;
				elm.mMultiselect.toggle.classList.remove( 'm-multiselect-toggle__inner--bold' );
			} else {
				// Something checked - swap in checkbox values and measure height
				elm.mMultiselect.toggleInner.innerHTML = elm.mMultiselect.selectedItems.join( ', ' );
				elm.mMultiselect.toggle.classList.add( 'm-multiselect-toggle__inner--bold' );
				tempHeight = elm.mMultiselect.toggleInner.getBoundingClientRect().height;

				if ( tempHeight <= elm.mMultiselect.toggleInnerHeight ) {
					// Everything fits - do nothing and keep checkbox values as they are
				} else {
					// Breaks to new line - swap in number of checkboxes checked
					elm.mMultiselect.toggleInner.innerHTML = elm.mMultiselect.selectedCount + elm.mMultiselect.selected;
					elm.mMultiselect.toggle.classList.add( 'm-multiselect-toggle__inner--bold' );
				}
			}
		},

		setMaxListHeight : function( elm ) {
			var resultsNum = elm.mMultiselect.checkboxGroupItems.length,
				index = 5, // 6th item
				tempElement,
				elementHeight,
				elementOffset;

			if ( elm.mMultiselect.currentBreakpoint === utility.smallTag ) {
				index = 3; // 4th item
			}

			elm.style.height = 'auto';

			if ( resultsNum <= index + 1 ) {
				// If only 4 or less at mobile or 6 or less at tablet and desktop do nothing
			} else {
				/*
				 * Get the offset of the item to be out of sight and the height of the previous one
				 * Set the height of the suggestion box to the offset minus half the height of the last item
				 * Add on 2px for the border
				 */
				elm.scrollTop = 0;
				tempElement = elm.mMultiselect.checkboxGroupItems[ index ];
				elementHeight = tempElement.clientHeight;
				elementOffset = tempElement.offsetTop;
				elm.style.height = utility.convertToPx( elementOffset + ( elementHeight / 2 ) + 2 );
				elm.scrollTop = elm.mMultiselect.scrollTopVal; // Reset the scrollTop position
			}
		},
	};

	return {
		initInstance : function( el ) {
			return mMultiselectFn.init( el );
		},
	};
});
